export const SelfStackIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.666 10.833c0 4.167-2.916 6.25-6.383 7.459a.83.83 0 0 1-.558-.009c-3.475-1.2-6.392-3.283-6.392-7.45V5a.833.833 0 0 1 .833-.833c1.667 0 3.75-1 5.2-2.267a.975.975 0 0 1 1.267 0c1.458 1.275 3.533 2.267 5.2 2.267a.833.833 0 0 1 .833.833z"
      stroke="#f4cd4d"
      stroke-width="1.667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
